module.exports = __webpack_public_path__ + "static/img/131.e9655e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/131.png
// module id = 6TyG
// module chunks = 0